
  import { Component, Prop } from 'vue-property-decorator'
  import { VHover } from 'vuetify/lib'

  @Component
  export default class ListItemHover extends VHover {
    @Prop({
      type: Function, default: () => {
        return;
      },
    }) private click!: (args: any) => void
  }
